import { useTranslation } from "react-i18next";
import { useBranding } from "../../../contexts/branding";

interface GooglePlayStoreLinkProps {
    onClick?: () => void;
}

export default function GooglePlayStoreLink({
    onClick,
}: GooglePlayStoreLinkProps) {
    const { t } = useTranslation();
    const { playStoreUrl } = useBranding();
    if (!playStoreUrl || playStoreUrl === "null") {
        return null;
    }

    return (
        <a
            href={playStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClick}
        >
            <img
                src="/images/google-play-badge.png"
                alt={t("Get it on Google Play")}
                height={82}
                width={188.95}
            />
        </a>
    );
}
